export var PopupType;
(function (PopupType) {
    PopupType["WARNING"] = "WARNING";
    PopupType["INFO"] = "INFO";
    PopupType["ERROR"] = "ERROR";
})(PopupType || (PopupType = {}));
//# sourceMappingURL=popup-message.types.js.map